const ACCOUNT_STATUS_ENUM = {
  INACTIVE: 'inactive',
  ACTIVE: 'active'
}

const isInactiveAccount = accountStatus => {
  return accountStatus.toLowerCase() === ACCOUNT_STATUS_ENUM.INACTIVE
}

const isActiveAccount = accountStatus => {
  return accountStatus.toLowerCase() === ACCOUNT_STATUS_ENUM.ACTIVE
}

export { ACCOUNT_STATUS_ENUM, isInactiveAccount, isActiveAccount }
